import h from 'hyperscript';

import { Modal } from 'ui/dialog/modal/modal';

const COMPONENT_NAME = 'd-loading-message-dialog';

/**
 * a simple modal containing a progress spinner next to a label
 */
export class LoadingMessageDialog extends Modal {
  #loadingMessage: Element | undefined;

  constructor() {
    super({});
    this.dialog.classList.add(COMPONENT_NAME);
  }

  removeLoadingMessage() {
    if (this.#loadingMessage) {
      this.#loadingMessage.remove();
    }
  }

  setLoadingMessage(message: string) {
    this.removeLoadingMessage();
    this.#loadingMessage = h('d-progress-spinner.d-progress-spinner-s', { label: message });
    this.body.append(this.#loadingMessage);
  }
}

customElements.define(COMPONENT_NAME, LoadingMessageDialog);
